import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {TalentHappyPathDataService} from "./talent-happy-path-data-service";
import * as cookies from "js-cookie";


export interface TalentHappyPathAuthentication {
  access_token?: string;
  id_token?: string;
  token_type?: 'Bearer';
  expiration_date?: Date;
}

export const STORAGE_KEY = 'authToken';

@Injectable({
  providedIn: 'root'
})
export class TalentHappyPathAuthService {

  private readonly authenticated = new BehaviorSubject<boolean>(false);
  private _authentication: TalentHappyPathAuthentication = null;

  constructor(private dataService: TalentHappyPathDataService) {
    this.readAuth();
  }

  private readAuth(): void {
    try {
      this._authentication = JSON.parse(cookies.get(STORAGE_KEY));
    } catch (e) {
      this._authentication = null;
    }
  }

  // @ts-ignore
  get authentication(): TalentHappyPathAuthentication {
    return this._authentication;
  }

  // @ts-ignore
  set authentication(auth: TalentHappyPathAuthentication) {
    if (auth && auth.id_token) {
      this._authentication = auth;
      const twoHours = 1/12;
      cookies.set(STORAGE_KEY, JSON.stringify(this._authentication), {
        domain: this.getDomain(),
        secure: true,
        expires: twoHours
      });
      this.authenticated.next(true);
      this.dataService.isAuthenticated = true;
    } else {
      this._authentication = null;
      cookies.remove(STORAGE_KEY);
      this.authenticated.next(false);
      this.dataService.isAuthenticated = false;
    }
  }

  getDomain(): string {
    window.location.hostname.split('.').pop()
    if (window.location.hostname.split('.').length < 3) {
      return window.location.hostname;
    } else {
      return window.location.hostname.split('.').slice(-2).join('.');
    }
  }

  isAuthenticated(): boolean {
    return (this.authentication && this.authentication.id_token && this.authentication.expiration_date)
          && !this.isExpired();
  }

  isExpired(): boolean {
    return new Date(this.authentication.expiration_date) < new Date(new Date().toISOString());
  }

  // TODO make _authentication BehaviorService so that we wont have to use this function when an angular component is reloaded without refresh
  reload(): void {
    this.readAuth();
  }

  clear(): void {
    this._authentication = null;
    cookies.remove(STORAGE_KEY, { domain: this.getDomain(), path: '/'});
    this.authenticated.next(false);
    this.dataService.isAuthenticated = false;
  }
}
